import { Pause, Play, CheckCircle, Clock, Loader } from "lucide-react";
import { useLocation } from "react-router-dom";
import "../../shared/tasks/tasks-layout.css";

const TaskHistoryPage = () => {
    const location = useLocation();
    const history = location.state?.history || [];
    const safeHistory = Array.isArray(history) ? history : [];

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        });
    };

    const getIcon = (event) => {
        switch (event) {
            case "pause":
                return <Pause size={16} className="text-warning" />;
            case "play":
                return <Play size={16} className="text-success" />;
            case "completed":
                return <CheckCircle size={16} className="text-primary" />;
            case "inprogress":
                return <Loader size={16} className="text-info animate-spin" />;
            default:
                return <Clock size={16} className="text-ink-muted" />;
        }
    };

    const resolveEvent = (title) => {
        if (title === "Completed") return "completed";
        if (title === "Paused") return "pause";
        if (title === "Continue Task") return "play";
        if (title === "In Progress") return "inprogress";
        return "default";
    };

    const sortedHistory = [...safeHistory].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    return (
        <div className="task-history-page">
            <header className="tasks-page__header">
                <h1 className="dashboard-title">Task History</h1>
            </header>

            {sortedHistory.length === 0 ? (
                <p className="text-sm text-ink-muted italic mt-4">No history available</p>
            ) : (
                <div className="task-history-page__list">
                    {sortedHistory.map((entry, index) => (
                        <div key={index} className="task-history-page__card">
                            <div className="shrink-0 mt-0.5">
                                {getIcon(resolveEvent(entry.title))}
                            </div>
                            <div className="flex flex-col leading-snug w-full min-w-0">
                                <p className="font-semibold text-ink">{entry.title}</p>
                                <p className="text-sm text-ink-muted mt-0.5">
                                    {formatTimestamp(entry.createdAt)}
                                </p>
                                {entry.notes && (
                                    <p className="text-sm text-ink-secondary italic mt-1">
                                        Reason: {entry.notes}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TaskHistoryPage;
